// NOTE: Ideally this would happen in a new window, however as this form
// is XHR / Promise based it is no longer considered user-initiated by
// the browser and thus it will be blocked by (built-in) popup-blockers.

export default {
  submit(attr = {}, fields = {}) {
    // Create a new hidden form in the DOM.
    const node = document.createElement('form');
    node.style.display = 'none';
    document.body.appendChild(node);

    // Copy form attributes
    for (const name in attr) {
      node.setAttribute(name, attr[name]);
    }

    // Add hidden fields
    for (const key in fields) {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', fields[key]);
      node.appendChild(input);
    }

    // Submit the form, and remove it from DOM.
    node.submit();
    document.body.removeChild(node);
  },
};
